import { createContext, useContext } from 'react';

import useInsightsGroupTypeManagement from 'components/insights/hooks/useInsightsGroupTypeManagement';
import GroupType from 'models/GroupType';
import Profile from 'models/Profile';

export type InsightsDashboardContextType = {
  profile: Profile;
  predecessorGroupType: GroupType | undefined;
  groupTypes: GroupType[];
  onTabChange: (groupType: GroupType) => void;
};

type Config = {
  preferenceKey: string;
  useSelectedGroupType: () => GroupType | undefined;
  useActions: () => {
    setSelectedGroupType: (groupType: GroupType | undefined) => void;
    setPredecessorGroupTypeId: (id: string | undefined) => void;
    resetFilters: () => void;
  };
  Page: React.ComponentType;
};

export default function createInsightsDashboardContainer({
  preferenceKey,
  useSelectedGroupType,
  useActions,
  Page,
}: Config) {
  const Context = createContext<InsightsDashboardContextType>({
    profile: {} as Profile,
    predecessorGroupType: undefined,
    groupTypes: [],
    onTabChange: () => {},
  });

  const useDashboardContext = () => useContext(Context);

  const Container = () => {
    const selectedGroupType = useSelectedGroupType();
    const { setSelectedGroupType, setPredecessorGroupTypeId, resetFilters } = useActions();

    const { profile, predecessorGroupType, groupTypes, handleTabChange } = useInsightsGroupTypeManagement({
      preferenceKey,
      setSelectedGroupType,
      setPredecessorGroupTypeId,
      resetFilters,
      selectedGroupType,
    });

    return (
      <Context value={{ profile, predecessorGroupType, groupTypes, onTabChange: handleTabChange }}>
        {predecessorGroupType && selectedGroupType && <Page />}
      </Context>
    );
  };

  return { Context, useDashboardContext, Container };
}
